import clsx from 'clsx'
import { useRouter } from 'next/router'
import InfiniteScroll from 'react-infinite-scroll-component'

import Header from 'app/ProfileRevampPage/components/SectionKarya/PerangkatAjar/Header'
import { EmptyState } from 'app/ProfileRevampPage/components/EmptyState'
import { LoadingState } from 'app/ProfileRevampPage/components/LoadingState'
import ToolkitCard from 'app/ProfileRevampPage/components/SectionKarya/PerangkatAjar/ToolkitCard'
import { getCategoryTitle } from 'app/ProfileRevampPage/utils/perangkatAjar'
import { usePerangkatAjar } from 'app/ProfileRevampPage/hooks/usePerangkatAjar'
import { useSETrackEventToolkits } from 'app/ProfileRevampPage/hooks/useSETrackEventToolkits'

const PerangkatAjarCategoryIndex = () => {
  const { query } = useRouter()
  const { id: profileId } = query
  const category = query?.category as string

  const {
    data: perangkatAjarList,
    meta: perangkatAjarMeta,
    fetchNextPage,
    hasNextPage,
    isLoading,
  } = usePerangkatAjar(profileId as string, category as string)
  const hasPerangkatAjarList = (perangkatAjarList ?? []).length > 0

  const { SETrackClickToolkitItem } = useSETrackEventToolkits()

  const onClickItem = (index, id) => {
    SETrackClickToolkitItem({
      toolkitType: category,
      toolkitLocation: index + 1,
      toolkitId: id,
      numTypeToolkit: perangkatAjarMeta?.[0]?.total ?? 0,
    })
  }

  return (
    <main
      className={clsx(
        'relative flex flex-col min-h-screen max-w-xl mx-auto',
        hasPerangkatAjarList && 'bg-surface-subdued'
      )}
    >
      <Header />
      <div className="pt-20 pb-4 px-4">
        {isLoading && <LoadingState />}

        {!isLoading && hasPerangkatAjarList && (
          <InfiniteScroll
            dataLength={perangkatAjarList.length}
            next={fetchNextPage}
            hasMore={hasNextPage}
            loader={<LoadingState />}
          >
            <div className="grid grid-cols-1 gap-4">
              {perangkatAjarList.map((toolkit, index) => (
                <ToolkitCard
                  key={toolkit?.id}
                  data={toolkit}
                  onClick={() => onClickItem(index, toolkit?.id)}
                />
              ))}
            </div>
          </InfiniteScroll>
        )}

        {!isLoading && !hasPerangkatAjarList && (
          <div className="mt-20 px-3">
            <EmptyState
              title="Belum ada Perangkat Ajar"
              description={`Kalau Anda mengunggah ${getCategoryTitle(
                category
              )}, nanti akan muncul di sini.`}
            />
          </div>
        )}
      </div>
    </main>
  )
}

export default PerangkatAjarCategoryIndex
